<app-hero-shell [backgroundImage]="heroConfig.backgroundImage">
  <ng-container slot="card">
    <h1 class="font-alternate text-h1 font-bold text-black">
      {{ 'Welcome to the website of' | translate }}
      <span class="text-mty-primary">{{ global.config.site_title }}</span>
    </h1>

    <h2 class="text-h3 font-semibold text-black">
      {{ 'Find your match and get discovered by employers' | translate }}
    </h2>

    <p class="text-h5 text-black">
      {{ 'Stay up to date with the latest developments via our social media' | translate }}
    </p>

    <div class="flex flex-row gap-3">
      @for (social of socials; track social.label) {
      <a [href]="social.href" target="_blank" rel="noopener noreferrer" [attr.aria-label]="social.label" class="inline-flex items-center justify-center w-12 h-12 bg-mty-primary rounded-2xl text-white no-underline">
        <fa-icon [icon]="social.icon" size="lg"></fa-icon>
      </a>
      }
    </div>

    <div class="flex flex-row gap-[5px] items-center -my-8">
      <a target="_blank" href="https://apps.apple.com/nl/app/meet-the-youngsters/id1586327238" class="inline-block">
        <img src="assets/img/icons/apple-app-store-svg.svg" alt="Download on the App Store" class="w-full max-w-[120px]" />
      </a>
      <a target="_blank" href="https://play.google.com/store/apps/details?id=nl.innervate.mty&pcampaignid=web_share" class="inline-block bg-white rounded p-[5px]">
        <img src="assets/img/icons/google-play-svg.svg" alt="Get it on Google Play" class="w-full max-w-[120px]" />
      </a>
    </div>

    <div class="flex flex-wrap items-center gap-3">
      <button class="bg-mty-primary text-white rounded-sm px-3 py-2 text-base font-semibold border-0 cursor-pointer transition-colors hover:opacity-90" (click)="landing.register()">
        {{ 'Sign up' | translate }}
      </button>
      <button class="text-black text-base font-medium bg-transparent border-0 cursor-pointer flex items-center gap-1">
        {{ 'Discover your benefits' | translate }}
        <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
        </svg>
      </button>
    </div>
  </ng-container>
  <app-video-player slot="video" [url]="heroConfig.videoUrl" />
</app-hero-shell>

<div class="relative overflow-hidden">
  <img src="assets/img/illustrations/dna-long.png" alt="" aria-hidden="true" class="absolute -top-4 -left-4 w-64 lg:w-80 opacity-90 pointer-events-none hidden md:block" />

  <app-audience-picker-section [cards]="audienceCards" theme="light">
    <h2 slot="heading" class="font-alternate text-[36px] leading-[44px] font-bold text-black m-0">
      {{ 'Your place within' | translate }}
      <span class="text-mty-primary">{{ 'Meet the Youngsters' | translate }}</span>
    </h2>
    <p slot="subtitle" class="text-[20px] leading-[26px] text-black m-0">
      {{ 'Choose your profile and discover how to use the platform your way.' | translate }}
    </p>
  </app-audience-picker-section>
</div>

<app-home-what-we-do-section />
<app-home-projects-section />
<app-home-videos-section />
<app-home-events-section />
<app-home-instagram-section />
<app-home-blog-section />
<app-home-statistics-section />
<app-home-partners-section />
<app-home-schools-section />
<app-home-newsletter-section />
